import "./css/dashboard.css"
import { useEffect, useState } from "react";

const Dashboard = () => {
    // इसे खाली ऑब्जेक्ट ({}) से इनिशियलाइज़ करना बेहतर है
    const [userinfo, setUserinfo] = useState({});
    const [status, setStatus] = useState();

    useEffect(() => {
        const url = process.env.REACT_APP_SERVER_URL;
        const data = {
            name: localStorage.getItem("name"),
            email: localStorage.getItem("email"),
            status: localStorage.getItem("status"),
            token: localStorage.getItem("token"),
            user_id: localStorage.getItem("user_id"),
        }
        
        // Page title
        document.title = "Dashboard";

        fetch(`${url}/user/user`, {
            method: "post",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${data.token}`
            },
        })
        .then((response) => response.json())
        .then((result) => {
            // अगर result.userinfo undefined आता है, तो ऐप क्रैश न हो इसलिए खाली ऑब्जेक्ट सेट करें
            setUserinfo(result.userinfo || {});
        })
        .catch((error) => console.error("Error fetching user info:", error));

        // Optional Chaining (?.) का इस्तेमाल ताकि undefined होने पर क्रैश न हो
        switch (userinfo?.status) {
            case 1:
                setStatus("Active");
                break;
            case 2:
                setStatus("Block");
                break;
            default:
                setStatus("Unknown");
        }

    }, [userinfo?.status]); // डिपेंडेंसी में भी Optional Chaining ज़रूरी है

    return (
        <div className="dashboardPageWrapper">
            <div className="dashboardMianContainer">
                <div className="dashboardHeader">
                    <h2>User Information</h2>
                    <p>View and manage your profile details</p>
                </div>
                
                <div className="dashBoardUserInfoMainContainer">
                    <div className="dashBoardUserInfoMainBox">
                        <div className="dashBoardUserIntoTitle">
                            <i className="fa-regular fa-user iconStyle"></i> Name
                        </div>
                        <div className="dashBoardUserIntodata">
                            {userinfo?.name || "N/A"}
                        </div>
                    </div>

                    <div className="dashBoardUserInfoMainBox">
                        <div className="dashBoardUserIntoTitle">
                            <i className="fa-regular fa-envelope iconStyle"></i> E-mail
                        </div>
                        <div className="dashBoardUserIntodata">
                            {userinfo?.email || "N/A"}
                        </div>
                    </div>

                    <div className="dashBoardUserInfoMainBox">
                        <div className="dashBoardUserIntoTitle">
                            <i className="fa-solid fa-hashtag iconStyle"></i> Enrollment Id
                        </div>
                        <div className="dashBoardUserIntodata">
                            {userinfo?.user_id || "N/A"}
                        </div>
                    </div>

                    <div className="dashBoardUserInfoMainBox">
                        <div className="dashBoardUserIntoTitle">
                            <i className="fa-solid fa-shield-halved iconStyle"></i> Status
                        </div>
                        <div className="dashBoardUserIntodata">
                            <span className={`statusBadge ${status === 'Active' ? 'activeStatus' : 'blockStatus'}`}>
                                {status || "Loading..."}
                            </span>
                        </div>
                    </div>

                    <div className="dashBoardUserInfoMainBox">
                        <div className="dashBoardUserIntoTitle">
                            <i className="fa-regular fa-calendar iconStyle"></i> Enrolled Date
                        </div>
                        <div className="dashBoardUserIntodata">
                            {userinfo?.date?.replace(/ /g, " / ")?.replace("Z", "") || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;